export default __webpack_public_path__ + "static/media/img7.81fde312.jpg";